import { getCssVar, getFullVariableName } from '../css-variable-utils';

/**
 * Known breakpoints.
 */
export type ThemeBreakpoint = 'sm' | 'md' | 'lg' | 'xl';

/**
 * @param bp Breakpoint
 * @returns
 * CSS variable for given breakpoint.
 */
export function getBreakpointCssVar(bp: ThemeBreakpoint): string {
  return getCssVar(`breakpoint--${bp}`);
}

/**
 * @param bp Breakpoint
 * @returns
 * CSS variable name for given breakpoint.
 * @example
 * getBreakpointCssVarName('sm') // `--fmnts-breakpoint--sm`
 */
export function getBreakpointCssVarName(bp: ThemeBreakpoint): string {
  return getFullVariableName(`breakpoint--${bp}`);
}
